import { render, staticRenderFns } from "./CodeDetail.vue?vue&type=template&id=14e2ed50&"
import script from "./CodeDetail.vue?vue&type=script&lang=js&"
export * from "./CodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./CodeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports